<template>
  <div class="artists-wrap">
    <el-row class="el-row artist-box" type="flex">
      <div
        class="view-toggle flex-center"
        :style="[
          window.width < '900' ? { display: 'none' } : { display: 'flex' }
        ]"
      >
        <p>View</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          :class="{ active: verticalView }"
          @click="verticalView = true"
        >
          <g
            id="Group_1745"
            data-name="Group 1745"
            transform="translate(-1498 -114)"
          >
            <line
              id="Line_86"
              data-name="Line 86"
              x2="18.833"
              transform="translate(1499.5 115.5)"
              fill="none"
              stroke="#868292"
              stroke-linecap="round"
              stroke-width="3"
            />
            <line
              id="Line_87"
              data-name="Line 87"
              x2="18.833"
              transform="translate(1499.5 121.056)"
              fill="none"
              stroke="#868292"
              stroke-linecap="round"
              stroke-width="3"
            />
            <line
              id="Line_88"
              data-name="Line 88"
              x2="18.833"
              transform="translate(1499.5 126.61)"
              fill="none"
              stroke="#868292"
              stroke-linecap="round"
              stroke-width="3"
            />
            <line
              id="Line_89"
              data-name="Line 89"
              x2="18.833"
              transform="translate(1499.5 132.166)"
              fill="none"
              stroke="#868292"
              stroke-linecap="round"
              stroke-width="3"
            />
          </g>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          :class="{ active: !verticalView }"
          @click="verticalView = false"
        >
          <g
            id="Group_1746"
            data-name="Group 1746"
            transform="translate(-1535 -116)"
          >
            <rect
              id="Rectangle_383"
              data-name="Rectangle 383"
              width="10"
              height="10"
              rx="2"
              transform="translate(1535 116)"
              fill="#868292"
            />
            <rect
              id="Rectangle_384"
              data-name="Rectangle 384"
              width="10"
              height="10"
              rx="2"
              transform="translate(1547 116)"
              fill="#868292"
            />
            <rect
              id="Rectangle_385"
              data-name="Rectangle 385"
              width="10"
              height="10"
              rx="2"
              transform="translate(1535 128)"
              fill="#868292"
            />
            <rect
              id="Rectangle_386"
              data-name="Rectangle 386"
              width="10"
              height="10"
              rx="2"
              transform="translate(1547 128)"
              fill="#868292"
            />
          </g>
        </svg>
      </div>

      <el-col
        class="add-item"
        :class="[
          verticalView && window.width > '900'
            ? 'horizontal-view-add-item mb20'
            : 'square-view-item'
        ]"
        style="margin-right: 20px"
      >
        <el-card class="flex-center align-center">
          <el-button
            icon="el-icon-plus dark-lg-icons"
            @click="openArtistModal('Add Artist')"
            circle
          ></el-button>
          <h3 class="name color-white">Add Artist</h3>
        </el-card>
      </el-col>

      <el-col
        :class="[
          verticalView && window.width > '900'
            ? 'horizontal-view-item'
            : 'square-view-item'
        ]"
        v-loading="loading"
        v-for="(artist, index) in artists"
        :key="index"
        style="margin-right: 20px"
      >
        <el-card v-if="artist.id">
          <div class="card-image">
            <el-image
              :src="`${url}artists/${artist.file_name}`"
              @error="imageFailed"
              :class="{ block: isError }"
            >
              <div slot="error" class="image-slot error-image-slot">
                <img src="@/assets/images/no_image.png" />
              </div>
            </el-image>
          </div>
          <h3 class="name flex-center">{{ artist.name }}</h3>
          <div class="align-wrap">
            <div class="stats flex-space-evenly">
              <div class="stat">
                <span class="value">{{ artist.previews }}</span>
                <span class="label">Previews</span>
              </div>
              <div class="stat">
                <span class="value">{{ artist.downloads }}</span>
                <span class="label">Downloads</span>
              </div>
              <div class="stat">
                <span class="value">{{ artist.tracks }}</span>
                <span class="label">Tracks</span>
              </div>
            </div>
            <div class="actions">
              <el-tooltip
                placement="right"
                effect="light"
                trigger="hover"
                v-if="artist.favorite_name == null"
              >
                <div slot="content">
                  Priority Artist
                </div>
                <el-button
                  :class="{ set: artist.favorite_name !== null }"
                  class="favorite"
                  icon="fas fa-star white-lg-icons"
                  circle
                  @click="addOrRemoveFavorite(artist.id)"
                ></el-button>
              </el-tooltip>
              <el-button
                v-else
                :class="{ set: artist.favorite_name !== null }"
                class="favorite"
                icon="fas fa-star white-lg-icons"
                circle
                @click="addOrRemoveFavorite(artist.id)"
              ></el-button>
              <el-tooltip placement="right" effect="light" trigger="hover">
                <div slot="content">
                  View Artist dashboard
                </div>
                <el-button
                  class="view"
                  icon="fas fa-eye white-lg-icons"
                  @click="openArtist(artist)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="right" effect="light" trigger="hover">
                <div slot="content">
                  Edit artist data
                </div>
                <el-button
                  @click="openArtistModal('Edit Artist', artist)"
                  class="edit"
                  icon="fas fa-pen white-lg-icons"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="right" effect="light" trigger="hover">
                <div slot="content">
                  Delete artist
                </div>
                <el-button
                  class="delete"
                  icon="el-icon-close white-lg-icons"
                  circle
                  @click="removeMyArtist(artist.id)"
                ></el-button>
              </el-tooltip>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="editDialog"
      width="700px"
      :before-close="handleClose"
    >
      <el-form :model="form">
        <el-form-item label="Artist Name" :label-width="formLabelWidth">
          <el-input
            v-model="form.name"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>

        <el-form-item label="Upload artist photo" :label-width="formLabelWidth">
          <el-upload
            class="el-upload-auto"
            :class="{
              'el-image-exist': form.file !== ''
            }"
            :action="`${url_label}myartists/image/upload/${form.id}`"
            :headers="headers"
            accept="image/*"
            :on-success="onSuccessArtistImage"
            :on-error="onErrorArtistImage"
            :on-remove="onRemoveArtistImage"
            :on-progress="onProgressArtistImage"
            name="file"
            ref="uploadArtistImage"
          >
            <i class="el-input__icon el-icon-upload aligh-icon"></i>

            <span v-if="form.file == ''">Choose file</span>
          </el-upload>
          <a
            v-if="form.file !== ''"
            :href="`${url}artists/${form.file}`"
            target="_blank"
          >
            {{ form.file }}
          </a>
          <i v-if="image_process" class="el-icon-loading loading-track"></i>
          <i
            v-if="form.file !== ''"
            class="el-icon-close removeIcon"
            @click="onRemoveArtistImage"
          ></i>
        </el-form-item>
        <el-form-item label="Spotify" :label-width="formLabelWidth">
          <el-input
            v-model="form.spotify"
            placeholder="Add Link"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="Facebook" :label-width="formLabelWidth">
          <el-input
            v-model="form.facebook"
            placeholder="Add Link"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="Instagram" :label-width="formLabelWidth">
          <el-input
            v-model="form.instagram"
            placeholder="Add Link"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="Website" :label-width="formLabelWidth">
          <el-input
            v-model="form.website"
            placeholder="Add Link"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="YouTube" :label-width="formLabelWidth">
          <el-input
            v-model="form.youtube"
            placeholder="Add Link"
            autocomplete="off"
            maxlength="100"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary btn-main" @click="confirmArtist"
          >Save</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

export default {
  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL,
      url_label: process.env.VUE_APP_LABEL_API_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      editDialog: false,
      verticalView: false,
      form: {},
      formLabelWidth: '120px',
      fileList: [],
      dialogTitle: '',
      isError: false,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image_process: false
    }
  },

  computed: {
    ...mapState('labelArtist', ['artists', 'loading'])
  },

  methods: {
    ...mapActions('labelArtist', [
      'read',
      'addRemoveFavorite',
      'removeArtist',
      'updateArtist',
      'saveArtist',
      'deleteImage',
      'getArtistId'
    ]),
    ...mapMutations('artistDashboard', ['setSelectedArtist']),

    openArtist(artist) {
      this.setSelectedArtist(artist)
      this.$router.push(`/label/my-artists/artist`)
    },
    openArtistModal(dialog_title, artist = null) {
      this.editDialog = true
      this.dialogTitle = dialog_title
      if (artist !== null) {
        this.form.id = artist.id
        this.form.name = artist.name
        this.form.file = artist.file_name !== null ? artist.file_name : ''
        this.form.spotify = artist.spotify
        this.form.facebook = artist.facebook
        this.form.instagram = artist.instagram
        this.form.website = artist.website
        this.form.youtube = artist.youtube
      } else {
        this.getArtistId().then(data => {
          this.form.id = data
        })
      }
    },
    handleClose(done) {
      this.$confirm('Your changes will not be saved. Are you sure?')
        .then(_ => {
          this.resetTrackForm()
          done()
        })
        .catch(_ => {})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`)
    },

    addOrRemoveFavorite(id) {
      this.addRemoveFavorite(id)
    },

    imageFailed() {
      this.isError = true
    },

    removeMyArtist(id) {
      this.$confirm('This will permanently delete the artist.', 'Warning', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.removeArtist(id)
          this.$message({
            type: 'success',
            message: 'Delete completed'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },

    resetTrackForm() {
      this.form = {
        id: null,
        name: '',
        file: '',
        spotify: '',
        facebook: '',
        instagram: '',
        website: '',
        youtube: ''
      }
    },

    confirmArtist() {
      if (this.form.name == '') {
        this.$message({
          type: 'warning',
          message: `You need to add artist name`
        })
      } else {
        this.editDialog = false
        if (this.dialogTitle == 'Edit Artist') {
          this.updateArtist(this.form)
        } else {
          this.saveArtist(this.form)
        }
        this.resetTrackForm()
      }
    },

    onSuccessArtistImage(response) {
      this.$message({
        type: 'success',
        message: `File uploaded`
      })
      this.image_process = false
      this.form.file = response.data.filename
    },

    onErrorArtistImage(err) {
      this.image_process = false
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemoveArtistImage() {
      this.deleteImage(this.form)
      this.form.file = ''
      this.$refs.uploadArtistImage.clearFiles()
    },

    onProgressArtistImage() {
      this.image_process = true
    }
  },

  created() {
    this.read()
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
    this.resetTrackForm()
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
  }
}
</script>

<style lang="scss" scoped>
.el-icon-plus {
  color: #0e0525;
  font-weight: 900;
}

.artists-wrap {
  width: 100%;
  max-width: 1295px;
  position: relative;
}

.view-toggle {
  position: absolute;
  top: -32px;
  right: 25px;
  p {
    margin: 0;
    margin-right: 10px;
    font-size: 22px;
  }
  svg {
    margin: 0 3px;
    cursor: pointer;
    &.active {
      line {
        stroke: #d40c41;
      }
      rect {
        fill: #d40c41;
      }
    }
  }
}

.el-row--flex {
  flex-wrap: wrap;
  align-self: flex-start;
}

.actions {
  .el-button + .el-button {
    margin-left: 0;
    margin-top: 4px;
  }
  .view:hover,
  .delete:hover {
    background-color: #d40c41;
  }
  .edit:hover {
    background-color: #2dfb06;
  }
  .favorite:hover {
    background-color: #ffa500;
  }
  .favorite.set {
    background-color: #ffa500;
  }
}

.card-header-slanted-edge {
  position: absolute;
  bottom: -7px;
  z-index: 1;
  width: 100%;
  right: 0;
  left: 0;
}

.btn-follow {
  position: absolute;
  top: 85px;
  right: 10px;
  padding: 8px;
  border: none;
  background: #df2758;
}

.removeIcon {
  float: right !important;
  margin-top: 15px !important;
  cursor: pointer;
}

.el-image-exist {
  width: 40px;
}
</style>
